var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useState } from 'react';
import { SelectBaseAsync, } from './SelectBase';
var MultiSelectAsync = function (_a) {
    var _b = _a.clearable, clearable = _b === void 0 ? true : _b, _c = _a.closeMenuOnSelect, closeMenuOnSelect = _c === void 0 ? false : _c, _d = _a.defaultOptions, defaultOptions = _d === void 0 ? [] : _d, _e = _a.initialOptions, initialOptions = _e === void 0 ? [] : _e, _f = _a.loadOptions, loadOptions = _f === void 0 ? function () { return Promise.resolve([]); } : _f, onChange = _a.onChange, _g = _a.placeholder, placeholder = _g === void 0 ? 'Search...' : _g, _h = _a.value, value = _h === void 0 ? [] : _h, rest = __rest(_a, ["clearable", "closeMenuOnSelect", "defaultOptions", "initialOptions", "loadOptions", "onChange", "placeholder", "value"]);
    var _j = __read(useState(initialOptions), 2), selectedOptions = _j[0], setSelectedOptions = _j[1];
    var handleChange = useCallback(function (options) {
        if (onChange) {
            setSelectedOptions(options);
            onChange(options.map(function (option) { return option.value; }));
        }
    }, [onChange]);
    return (React.createElement(SelectBaseAsync, __assign({}, rest, { clearable: clearable, closeMenuOnSelect: closeMenuOnSelect, defaultOptions: defaultOptions, loadOptions: loadOptions, multiselect: true, onChange: handleChange, placeholder: placeholder, value: selectedOptions.filter(function (opt) { return value.includes(opt.value); }) })));
};
export default MultiSelectAsync;
//# sourceMappingURL=MultiSelectAsync.js.map